import './LandingPage.scss';
import { useGA4 } from '../utils/ga4';

import { Browser } from '@capacitor/browser';
import { IonCol, IonContent, IonGrid, IonIcon, IonPage, IonRow, useIonRouter } from '@ionic/react';
import React from 'react';
import { useIntl } from 'react-intl';
import { useHistory } from 'react-router';
import {
  ResourceLink,
  contactLink,
  jettingCalculatorLink,
  productInformationLink,
  trainingLink,
  warthogSewerToolsLink,
  waterblastToolsLink,
} from 'src/constants';
import sentinelLinkTileImage from '../assets/images/icon-sentinel_link.png'; // TODO: replace this PNG image with an SVG image [SSB-549].
import stoneAgeLogo from '../assets/images/logo-dm-stoneage.png';
import SupportCard from '../components/experience-card/SupportCard';
import NavCard from '../components/nav-card/NavCard';
import { GenericMessages } from '../intl/GenericMessages';
import { NavCardMessages } from '../intl/NavCardMessages';
import { AccessDeniedModal } from './AccessDeniedModal';

const resourceLinks: ResourceLink[] = [
  jettingCalculatorLink,
  productInformationLink,
  waterblastToolsLink,
  warthogSewerToolsLink,
  trainingLink,
];

export const LandingPage: React.FC = () => {
  document.title = 'Landing Page'; // Purposely English only for Google Analytics
  useGA4();

  const history = useHistory();
  const router = useIonRouter();
  const showAccessDenied = router.routeInfo.search.includes('accessDenied');
  const { formatMessage } = useIntl();

  const openBrowser = async (url?: string) => {
    if (url) {
      await Browser.open({ url, presentationStyle: 'popover', windowName: '_blank' });
    }
  };

  return (
    <IonPage>
      <IonContent className="landing-page">
        <img className="landing-page-logo" src={stoneAgeLogo} alt={formatMessage(GenericMessages.stoneAgeLogo)} />
        <IonGrid className={'landing-page-grid'}>
          <IonRow>
            <IonCol
              size="6"
              sizeMd="4"
              onClick={() => history.push('/welcome')}
              key={NavCardMessages.sentinelLinkTitle.id}
              data-testid={`welcomeTile-sentinelLink`}
            >
              {/* TODO when PNG is replaced with SVG, change img to IonIcon [SSB-549] */}
              <NavCard
                title={formatMessage(NavCardMessages.sentinelLinkTitle)}
                subtitle={formatMessage(NavCardMessages.sentinelLinkSubtitle)}
                icon={<img className="nav-card-png-tech-debt" src={sentinelLinkTileImage} alt={''} />}
              />
            </IonCol>
            {resourceLinks.map(item => (
              <IonCol
                size="6"
                sizeMd="4"
                onClick={() => openBrowser(item.actionUrl)}
                key={item.title.id}
                data-testid={`welcomeTile-${item.automationId}`}
              >
                {/* TODO eliminate this conditional and just use NavCard with IonIcon for SVG image [SSB-549] */}
                {item.iconIsPng ? (
                  <NavCard
                    title={formatMessage(item.title)}
                    subtitle={formatMessage(item.subtitle)}
                    icon={<img className="nav-card-png-tech-debt" src={item.icon} alt={''} />}
                  />
                ) : (
                  <NavCard
                    title={formatMessage(item.title)}
                    subtitle={formatMessage(item.subtitle)}
                    icon={<IonIcon icon={item.icon} color="primary" />}
                  />
                )}
              </IonCol>
            ))}
          </IonRow>
          <IonRow>
            <IonCol size="12">
              <SupportCard
                buttonText={formatMessage(contactLink.buttonText)}
                title={formatMessage(contactLink.title)}
                subtitle={formatMessage(contactLink.subtitle)}
                onClick={() => openBrowser(contactLink.actionUrl)}
              />
            </IonCol>
          </IonRow>
        </IonGrid>
        <AccessDeniedModal isOpen={showAccessDenied} />
      </IonContent>
    </IonPage>
  );
};
